<template>
  <div>
    <v-data-table class="astra-table" dense height="74vh" fixed-header :headers="controller.headers"
      :options.sync="controller.options" :server-items-length="controller.serviceOrderPagination.total"
      :items="controller.serviceOrderPagination.items" :loading="controller.loading" :footer-props="{
        'items-per-page-options': [40, 80],
      }" :sort-by="controller.options.sortBy" must-sort>
      <template v-slot:[`item.active`]="{ item }">
        <v-checkbox color="primary" class="mt-0 pt-0" v-model="item.active" hide-details readonly dense>
        </v-checkbox>
      </template>
      <template v-slot:[`item.createdDate`]="{ item }">
        {{
          item.createdDate
            ? dayjs(item.createdDate).format("DD/MM/YYYY HH:mm")
            : "---"
        }}
      </template>
      <template v-slot:[`item.startDate`]="{ item }">
        {{
          item.startDate ? dayjs(item.startDate).format("DD/MM/YYYY") : "---"
        }}
      </template>
      <template v-slot:[`item.endDate`]="{ item }">
        {{ item.endDate ? dayjs(item.endDate).format("DD/MM/YYYY") : "---" }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div>
          <v-btn icon @click="controller.updateStatusOpen(item)" class="px-2" v-if="hadPermission(20, 2)">
            <v-icon color="#C0CA33" small>mdi-swap-horizontal</v-icon>
          </v-btn>
        </div>
        <div v-if="item.approvedDate == null">
          <v-btn icon @click="controller.openFormDynamic(item)" class="px-2" v-if="hadPermission(20, 2)">
            <v-icon color="#C0CA33" small>mdi-invoice-text-plus</v-icon>
          </v-btn>
        </div>
        <div v-else>
          <v-btn icon class="px-2" disabled v-if="hadPermission(20, 2)">
            <v-icon small>mdi-invoice-text-plus</v-icon>
          </v-btn>
        </div>
        <div v-if="item.approvedDate != null">
          <v-btn icon @click="controller.generateReport(item)" class="px-2" v-if="hadPermission(0,0)">
            <v-icon color="#C0CA33" small>mdi-download</v-icon>
          </v-btn>
        </div>
        <div v-else>
          <v-btn icon class="px-2" disabled v-if="hadPermission(0,0)">
            <v-icon small>mdi-download</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:top>
        <v-row class="pa-3" no-gutters>
          <v-col :class="$vuetify.breakpoint.smAndDown
              ? 'py-3 d-flex align-center justify-center'
              : 'd-flex align-center'
            " cols="12" sm="12" md="6" lg="6" xl="6">
            <span class="table-title">Visitas</span>
          </v-col>
          <v-col :class="$vuetify.breakpoint.smAndDown
              ? 'd-flex flex-column align-center justify-center'
              : 'd-flex align-center justify-end'
            " cols="12" sm="12" md="6" lg="6" xl="6">
            <div style="width: 200px">
              <v-select outlined dense color="primary" v-model="controller.statusSelected"
                :items="controller.statusList" hide-details class="pa-2 search-tf" item-text="text" item-value="value"
                @change="controller.changeStatus()"></v-select>
            </div>
            <div style="width: 200px">
              <v-text-field class="px-2 search-tf" outlined color="primary" hide-details dense
                placeholder="Pesquisar..." v-model="controller.search"></v-text-field>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
    <v-dialog max-width="600" persistent scrollable v-model="controller.dialogUpdateStatus">
      <v-card class="crud-card">
        <v-card-title class="d-flex justify-center">Alterar Status da Tarefa</v-card-title>
        <v-card-text>
          <v-form ref="crudUpdateStatus" lazy-validation>
            <div class="form-input-group">
              <v-autocomplete class="search-tf" single-line id="status" :rules="[(v) => !!v || 'Campo obrigatório']"
                background-color="transparent" outlined required dense placeholder="Status da Tarefa"
                v-model="controller.formUpdateStatus.serviceOrderStatusID" :search-input.sync="controller.searchStatus"
                :items="controller.statusPagination.items" item-text="name" item-value="id" />
              <label for="status">Status da Tarefa</label>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-3">
          <v-btn class="action-btn d-flex justify-center" height="36" width="114" color="primary" tile outlined
            @click="controller.closeUpdateStatus()">
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="action-btn d-flex justify-center" height="36" width="114" color="primary" tile
            @click="controller.updateStatus()" :loading="controller.loadingUpdateStatus">
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog max-width="1100" persistent v-model="controller.formDynamic" content-class="report-dialog">
      <div v-if="$vuetify.breakpoint.mdAndUp">
        <v-card>
          <v-card-title>Relatório de Ordem de Serviço</v-card-title>
          <v-card-text>
            <v-form ref="tabsForms" lazy-validation>
              <v-row>
                <v-col
                  align-self="stretch"
                  cols="12"
                  md="4"
                >
                  <v-tabs
                    v-model="controller.tabs"
                    vertical
                    show-arrows
                    @input="controller.onTabsInput"
                    @change="controller.onTabChange()"
                  >
                    <v-tab
                      v-for="(field, index) in controller.fields"
                      :key="index"
                      :disabled="!controller.canEnterTab(index)"
                    >{{field.title }}</v-tab>
                  </v-tabs>
                </v-col>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-tabs-items v-model="controller.tabs" @input="controller.onTabsInput" @change="controller.onTabChange()" touchless>
                    <v-tab-item
                      v-for="(field, fieldKey) in controller.fields"
                      :key="field.key || fieldKey"
                    >
                      <div v-if="field.properties && controller.form.reportData && controller.form.reportData[field.key]">
                          <v-row>    
                            <v-col cols="6" v-for="([propKey, prop], idx) in field.orderedProperties" :key="`prop-${fieldKey}-${propKey}`">
                              <div v-if="prop.type == 'string' && prop.format != 'date-time'">
                                <v-text-field v-model="controller.form.reportData[field.key][propKey]" :label="prop.title"
                                  :readonly="prop.readOnly === true"
                                  :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                  :loading="controller.isSaving(field.key, propKey)"
                                  :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                                  @blur="controller.patchServiceOrderReport(prop, propKey, field.key)"></v-text-field>
                              </div>
                              <div v-else-if="prop.type == 'boolean'">
                                <v-radio-group
                                  v-model="controller.form.reportData[field.key][propKey]"
                                  :readonly="prop.readOnly === true"
                                  :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                  :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                                  :label="prop.title"
                                  @change="controller.patchServiceOrderReport(prop, propKey, field.key)"
                                >
                                  <v-radio :label="prop.displayFormat === 'conformity' ? 'Conforme' : 'Sim'" :value="true" />
                                  <v-radio :label="prop.displayFormat === 'conformity' ? 'Inconforme' : 'Não'" :value="false" />
                                </v-radio-group>
                              </div>
                              <div v-else-if="prop.format == 'date-time' && prop.readOnly !== true">
                                <div class="form-input-group">
                                  <date-picker lass="search-tf" id="prop.title" single-line background-color="transparent" outlined
                                    required dense :label="prop.title" v-model="controller.form.reportData[field.key][propKey]"
                                    :readonly="prop.readOnly === true"
                                    :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                    @input="controller.patchServiceOrderReport(prop, propKey, field.key)"></date-picker>
                                  <label for="prop.title">{{ prop.title }}</label>
                                </div>
                              </div>
                              <div v-else-if="prop.format == 'date-time' && prop.readOnly === true">
                              </div>
                              <div v-else-if="prop.type == 'array' && (prop.format === 'signature' || (propKey && String(propKey).endsWith('_signature')))">
                                <div class="form-input-group">
                                  <label class="mb-2">{{ prop.title || 'Assinatura' }}</label>
                                  <div class="d-flex flex-column">
                                    <canvas
                                      :ref="el => controller.setSignatureReference(propKey, el)"
                                      style="border: 1px solid #ccc; border-radius: 4px; width: 100%; height: 200px; touch-action: none;"
                                      @mousedown="(e) => controller.signatureStart(propKey, e)"
                                      @mousemove="(e) => controller.signatureMove(propKey, e)"
                                      @mouseup="() => controller.signatureEnd(propKey)"
                                      @mouseleave="() => controller.signatureEnd(propKey)"
                                      @touchstart.prevent="(e) => controller.signatureStart(propKey, e)"
                                      @touchmove.prevent="(e) => controller.signatureMove(propKey, e)"
                                      @touchend.prevent="() => controller.signatureEnd(propKey)"
                                    ></canvas>
                                    <div class="mt-2 d-flex" style="gap: 8px;">
                                      <v-btn small color="primary" @click="controller.saveSignature(propKey)">Salvar assinatura</v-btn>
                                      <v-btn small outlined color="primary" @click="controller.clearSignature(propKey)">Limpar</v-btn>
                                    </div>
                                  </div>
                                  <v-input
                                    class="d-none"
                                    :rules="controller.rulesFor(field.key, propKey, 'array')"
                                    :value="controller.form.images"
                                  />
                                </div>
                                <v-row class="mt-2">
                                  <div v-if="controller.form.images && controller.form.images.length">
                                    <template v-for="obj in controller.form.images">
                                      <v-col
                                        v-if="obj.formFieldKey === propKey"
                                        :key="obj.signURL || obj.formFieldKey"
                                        class="photo"
                                      >
                                        <v-input :value="obj.signURL">
                                          <v-img
                                            :src="obj.signURL" 
                                            max-height="100%" 
                                            @load="controller.loading = false" 
                                            class="photo-img"
                                          >
                                             <template v-if="controller.loading == true">
                                                <div class="d-flex align-center justify-center" style="height: 100%">
                                                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                                </div>
                                              </template>
                                          </v-img>
                                        </v-input>
                                      </v-col>
                                    </template>
                                  </div>
                                  <div v-else><span>Nenhuma assinatura foi encontrada</span></div>
                                </v-row>
                              </div>
                              <div v-else-if="prop.type == 'array'">
                                <div class="form-input-group">
                                  <v-file-input 
                                  v-if="hadPermission(0,0)"
                                  style="display: flex" id="photo" :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                    :disabled="prop.readOnly === true"
                                    accept="image/png, image/jpeg, image/heic, image/heif, image/avif, .heic, .heif, .avif, .raw, .dng, .arw, .cr2, .nef" placeholder="Selecione um arquivo" truncate-length="50"
                                    :label="prop.title" show-size
                                    :loading="controller.isSaving(field.key, propKey) || controller.isUploading(field.key, propKey) || controller.isImageLoading(field.key, propKey)"
                                    :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                                    @change="(file) => controller.serviceOrderReportImage(file, propKey)"></v-file-input>
                                </div>
                                <div v-if="controller.form.images && controller.form.images.length">
                                  <template v-for="obj in controller.form.images">
                                    <v-col
                                      v-if="obj.formFieldKey === propKey"
                                      :key="obj.s3Key || obj.signURL || obj.formFieldKey"
                                      class="photo-desktop"
                                    >
                                      <v-input
                                        :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                        :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                                        :value="obj.signURL"
                                      >
                                        <v-img 
                                          :src="obj.signURL"
                                          max-height="100%"
                                          @load="controller.onImageLoaded(propKey)" @error="controller.onImageLoaded(propKey)"
                                          class="photo-img"
                                        >
                                          <template v-if="controller.isUploading(field.key, propKey) || controller.isImageLoading(field.key, propKey)">
                                            <div class="d-flex align-center justify-center" style="height: 100%">
                                              <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                            </div>
                                          </template>
                                        </v-img>
                                      </v-input>
                                    </v-col>
                                  </template>
                                </div>
                                <div v-else><span>Nenhuma foto foi encontrada</span></div>
                              </div>
                              <div v-else-if="prop.type === 'integer' && prop.readOnly !== true">
                                <span>{{ prop.title }}</span>
                              </div>
                              
                            </v-col>
                          </v-row>
                        </div>
                        <div v-else-if="field.type === 'array'">
                          <div class="form-input-group">
                            <v-row>
                              <v-col>
                                  <v-file-input 
                                  v-if="hadPermission(0,0)"
                                  style="display: flex" id="photo"
                                  accept="image/png, image/jpeg, image/heic, image/heif, image/avif, .heic, .heif, .avif, .raw, .dng, .arw, .cr2, .nef" placeholder="Selecione um arquivo" truncate-length="50"
                                  :label="field.title" show-size
                                  :loading="controller.isSaving(field.key) || controller.isUploading(field.key) || controller.isImageLoading(field.key)"
                                  :error-messages="controller.fieldError(field.key) ? [controller.fieldError(field.key)] : []"
                                  @change="(file) => controller.serviceOrderReportImage(file, field.key)"></v-file-input>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col style="align-content: center; justify-items: center">
                                <div v-if="controller.form.images && controller.form.images.length">
                                  <v-col
                                    v-for="obj in controller.form.images"
                                    v-if="obj.formFieldKey === field.key"
                                    :key="obj.s3Key || obj.signURL || obj.formFieldKey"
                                  >
                                    <v-img
                                      :src="obj.signURL"
                                      max-height="100%"
                                      @load="controller.onImageLoaded(field.key)" @error="controller.onImageLoaded(field.key)"
                                      class="photo-desktop"
                                    >
                                      <template v-if="controller.isUploading(field.key) || controller.isImageLoading(field.key)">
                                        <div class="d-flex align-center justify-center" style="height: 100%">
                                          <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                        </div>
                                      </template>
                                    </v-img>
                                  </v-col>
                                </div>
                                <div v-else><span>Nenhuma foto foi encontrada</span></div>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="action-btn d-flex justify-center" height="36" width="114" color="primary" tile outlined
              @click="controller.closeFormDynamic(); controller.formDynamic = false;">
              <v-icon left>mdi-close</v-icon>
              Fechar
            </v-btn>
            <v-btn
              v-if="controller.isReportComplete() && !controller.form?.approvedDate && !controller.form?.submittedDate"
              class="action-btn d-flex justify-center" height="36" width="160" color="primary" tile
              @click="controller.submitReport()"
            >
              <v-icon left>mdi-send</v-icon>
              Enviar relatório
            </v-btn>
            <v-btn v-else-if="controller.isReportComplete() && controller.form?.submittedDate" disabled
              class="action-btn d-flex justify-center" height="36" width="200" color="primary" tile
              >
              Aguardando Aprovação
            </v-btn>
            <v-btn
              v-if="controller.isReportComplete() && controller.form?.submittedDate && !controller.form?.approvedDate && hadPermission(0,0)"
              class="action-btn d-flex justify-center" height="36" width="180" color="success" tile
              @click="controller.approveReport(controller.form)"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Aprovar relatório
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
      <div v-if="$vuetify.breakpoint.smAndDown" class="dialogBreakSm">
        <v-card :ripple="false">
          <v-card-title>Relatório de Ordem de Serviço</v-card-title>
          <v-card-text>
            <v-alert
              v-if="controller.startDate"
              icon="mdi-calendar"
              shaped
              dense
              center-active
              align-with-title
            >Início: {{dayjs(controller.startDate).format('DD/MM/YYYY - HH:mm') }}</v-alert>
            <v-form 
              ref="tabsForms"
              lazy-validation
            >
              <v-tabs
                v-model="controller.tabs"
                vertical
                show-arrows
                @input="controller.onTabsInput"
                @change="controller.onTabChange()"
                center-active
                align-with-title
              >
                <v-tab
                  v-for="(field, index) in controller.fields"
                  :key="index"
                  :disabled="!controller.canEnterTab(index)"
                >{{ field.title }}</v-tab>
              </v-tabs>
                  <v-tabs-items
                    v-model="controller.tabs"
                    @input="controller.onTabsInput"
                    @change="controller.onTabChange()"
                    touchless
                  >
                    <v-tab-item
                      v-for="(field, index) in controller.fields"
                      :key="field.key || index"
                    >
                      <div v-if="field.properties && controller.form.reportData && controller.form.reportData[field.key]">
                        <v-row>
                          <v-col cols="12" v-for="([propKey, prop], idx) in field.orderedProperties" :key="propKey">
                            <div v-if="prop.type == 'string' && prop.format != 'date-time'">
                            <v-text-field v-model="controller.form.reportData[field.key][propKey]" :label="prop.title"
                              :readonly="prop.readOnly === true"
                              @blur="controller.patchServiceOrderReport(prop, propKey, field.key)" required :rules="controller.rulesFor(field.key, propKey, prop.type)"
                              :loading="controller.isSaving(field.key, propKey)"
                              :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                            ></v-text-field>
                          </div>
                          <div v-else-if="prop.type == 'boolean'">
                            <v-radio-group
                              v-model="controller.form.reportData[field.key][propKey]"
                              :readonly="prop.readOnly === true"
                              @change="controller.patchServiceOrderReport(prop, propKey, field.key)"
                              required
                              :rules="controller.rulesFor(field.key, propKey, prop.type)"
                              :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                              :label="prop.title"
                            >
                              <v-radio :label="prop.displayFormat === 'conformity' ? 'Conforme' : 'Sim'" :value="true" />
                              <v-radio :label="prop.displayFormat === 'conformity' ? 'Inconforme' : 'Não'" :value="false" />
                            </v-radio-group>
                          </div>
                            <div v-else-if="prop.format == 'date-time' && prop.readOnly !== true">
                              <div class="form-input-group">
                                <date-picker class="search-tf" id="prop.title" single-line background-color="transparent"
                                  outlined required dense :label="prop.title" v-model="controller.form.reportData[field.key][propKey]"
                                  :readonly="prop.readOnly === true"
                                  :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                  @input="controller.patchServiceOrderReport(prop, propKey, field.key)"></date-picker>
                                <label for="prop.title">{{ prop.title }}</label>
                              </div>
                            </div>
                            <div v-else-if="prop.format == 'date-time' && prop.readOnly === true"></div>
                            <div v-else-if="prop.type === 'integer' && prop.readOnly === true"></div>
                            <div v-else-if="prop.type == 'array' && (prop.format === 'signature' || (propKey && String(propKey).endsWith('_signature')))">
                              <div class="form-input-group">
                                <label class="mb-2">{{ prop.title || 'Assinatura' }}</label>
                                <div class="d-flex flex-column">
                                  <canvas
                                    :ref="el => controller.setSignatureReference(propKey, el)"
                                    style="border: 1px solid #ccc; border-radius: 4px; width: 100%; height: 200px; touch-action: none;"
                                    @mousedown="(e) => controller.signatureStart(propKey, e)"
                                    @mousemove="(e) => controller.signatureMove(propKey, e)"
                                    @mouseup="() => controller.signatureEnd(propKey)"
                                    @mouseleave="() => controller.signatureEnd(propKey)"
                                    @touchstart.prevent="(e) => controller.signatureStart(propKey, e)"
                                    @touchmove.prevent="(e) => controller.signatureMove(propKey, e)"
                                    @touchend.prevent="() => controller.signatureEnd(propKey)"
                                  ></canvas>
                                  <div class="mt-2 d-flex" style="gap: 8px;">
                                    <v-btn small color="primary" @click="controller.saveSignature(propKey)">Salvar assinatura</v-btn>
                                    <v-btn small outlined color="primary" @click="controller.clearSignature(propKey)">Limpar</v-btn>
                                  </div>
                                </div>
                                <v-input
                                  class="d-none"
                                  :rules="controller.rulesFor(field.key, propKey, 'array')"
                                  :value="controller.form.images"
                                />
                              </div>
                              <v-row class="mt-2">
                                <div v-if="controller.form.images && controller.form.images.length">
                                  <template v-for="obj in controller.form.images">
                                    <v-col
                                      v-if="obj.formFieldKey === propKey"
                                      :key="obj.s3Key || obj.signURL || obj.formFieldKey"
                                      class="photo"
                                    >
                                      <v-input :value="obj.signURL">
                                        <v-img :src="obj.signURL" max-height="100%" @load="controller.onImageLoaded(propKey)" @error="controller.onImageLoaded(propKey)" class="photo-img">
                                          <template v-if="controller.isUploading(field.key, propKey) || controller.isImageLoading(field.key, propKey)">
                                            <div class="d-flex align-center justify-center" style="height: 100%">
                                              <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                            </div>
                                          </template>
                                        </v-img>
                                      </v-input>
                                    </v-col>
                                  </template>
                                </div>
                                <div v-else><span>Nenhuma assinatura foi encontrada</span></div>
                              </v-row>
                            </div>
                            <div v-else-if="prop.type == 'array'">
                            <div class="form-input-group">
                              <v-row>
                                <v-col>
                                  <div class="form-input-group">
                                    <v-btn prepend-icon @click="controller.initializeCamera(prop, propKey, $event.target)" :disabled="prop.readOnly === true">
                                      <v-icon>mdi-camera-outline</v-icon>
                                      Tirar foto</v-btn>
                                    <label for="">{{ prop.title }}</label>
                                    <v-file-input 
                                      v-if="hadPermission(0,0)"
                                      style="display: flex" :id="`photo-${propKey}`"
                                      accept="image/png, image/jpeg, image/heic, image/heif, image/avif, .heic, .heif, .avif, .raw, .dng, .arw, .cr2, .nef" placeholder="Selecione um arquivo" truncate-length="50"
                                      :label="prop.title" show-size
                                      :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                      :loading="controller.isSaving(field.key, propKey) || controller.isUploading(field.key, propKey)"
                                      :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                                      @change="(file) => controller.serviceOrderReportImage(file, propKey)"
                                    ></v-file-input>
                                  </div>
                                </v-col>
                              </v-row>
                              <v-row>
                                <div v-if="controller.constraints.video && controller.constraints.id === propKey" :data-camera-field="propKey" class="take-photo-sm">
                                  <video :ref="video => controller.setCameraReference(propKey, video)" autoplay playsinline webkit-playsinline muted
                                    style="width: 100%; height: 100%; border-radius: 12px;"></video>
                                  <v-btn @click="controller.takePicture(prop, propKey)" :disabled="prop.readOnly === true" icon style="
                                      position: absolute;
                                      bottom: 10px;
                                      left: 50%;
                                      transform: translateX(-50%);
                                      z-index: 10;
                                    ">
                                    <v-icon color="#ffffff">mdi-circle-outline</v-icon>
                                  </v-btn>
                                </div>
                                <div v-else style="display: none">
                                  <span>Nenhuma câmera foi encontrada</span>
                                </div>
                              </v-row>
                              <v-row class="row-sm">
                                <div v-if="controller.form.images && controller.form.images.length">
                                  <template v-for="obj in controller.form.images">
                                    <v-col
                                      v-if="obj.formFieldKey === propKey"
                                      :key="obj.s3Key || obj.signURL || obj.formFieldKey"
                                      class="photo"
                                    >
                                      <v-input
                                        :rules="controller.rulesFor(field.key, propKey, prop.type)"
                                        :error-messages="controller.fieldError(field.key, propKey) ? [controller.fieldError(field.key, propKey)] : []"
                                        :value="obj.signURL"
                                      >
                                        <v-img 
                                          :src="obj.signURL"
                                          max-height="100%"
                                          @load="controller.onImageLoaded(propKey)" @error="controller.onImageLoaded(propKey)"
                                          class="photo-img"
                                        >
                                          <template v-if="controller.isUploading(field.key, propKey) || controller.isImageLoading(field.key, propKey)">
                                            <div class="d-flex align-center justify-center" style="height: 100%">
                                              <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                            </div>
                                          </template>
                                        </v-img>
                                      </v-input>
                                    </v-col>
                                  </template>
                                </div>
                                <div v-else-if="controller.isUploading(field.key, propKey)" class="photo">
                                  <div class="d-flex align-center justify-center photo-img" style="height: 160px;">
                                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                  </div>
                                </div>
                                <div v-else><span>Nenhuma foto foi encontrada</span></div>
                              </v-row>
                              </div>
                            </div>
                            <div v-else-if="prop.format == 'date-time' && prop.readOnly === true">
                              
                            </div>
                            <div v-else><span>Tipo do campo desconhecido</span></div>
                          </v-col>
                        </v-row>
                      </div>
                      <div v-else-if="!field.properties && field.type == 'array'">
                        <div class="form-input-group">
                          <v-row>
                            <v-col>
                              <div class="form-input-group">
                                <v-btn prepend-icon @click="controller.initializeCamera(field, index)">
                                  <v-icon>mdi-camera-outline</v-icon>
                                  Tirar foto</v-btn>
                                <v-file-input 
                                v-if="hadPermission(0,0)"
                                style="display: flex" id="photo-root"
                                  accept="image/png, image/jpeg, image/heic, image/heif, image/avif, .heic, .heif, .avif, .raw, .dng, .arw, .cr2, .nef" placeholder="Selecione um arquivo" truncate-length="50"
                                  :label="field.title" show-size
                                  :rules="controller.rulesFor(field.key, field.key, 'array')"
                                  :loading="controller.isUploading(field.key) || controller.isSaving(field.key)"
                                  @change="(file) => controller.serviceOrderReportImage(file, field.key)"
                                ></v-file-input>
                                <label for="">{{ field.title }}</label>
                              </div>
                            </v-col>
                          </v-row>
                          <v-row>
                            <div v-if="controller.constraints.video" class="take-photo-sm">
                              <video :ref="video => controller.setCameraReference(field, video)" autoplay playsinline webkit-playsinline muted
                                style="width: 100%; height: 100%; border-radius: 12px;"></video>
                              <v-btn @click="controller.takePicture(field, index)" icon style="
                                  position: absolute;
                                  bottom: 10px;
                                  left: 50%;
                                  transform: translateX(-50%);
                                  z-index: 10;
                                ">
                                <v-icon color="#ffffff">mdi-circle-outline</v-icon>
                              </v-btn>
                            </div>
                            <div v-else style="display: none">
                              <span>Nenhuma câmera foi encontrada</span>
                            </div>
                          </v-row>
                          <v-row class="row-sm">
                            <v-col style="align-content: center; justify-items: center">
                              <div v-if="controller.form.images && controller.form.images.length">
                                <v-col
                                  v-for="obj in controller.form.images"
                                  v-if="obj.formFieldKey === field.key"
                                  :key="obj.s3Key || obj.signURL || obj.formFieldKey"
                                  class="photo"
                                >
                                  <v-input
                                    :value="obj.signURL"
                                  >
                                    <v-img
                                      :src="obj.signURL"
                                      max-height="100%"
                                      @load="controller.onImageLoaded(field.key)" @error="controller.onImageLoaded(field.key)"
                                      class="photo-img"
                                    >
                                      <template v-if="controller.isUploading(field.key) || controller.isImageLoading(field.key)">
                                        <div class="d-flex align-center justify-center" style="height: 100%">
                                          <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                        </div>
                                      </template>
                                    </v-img>
                                  </v-input>
                                </v-col>
                              </div>
                              <div v-else-if="controller.isUploading(field.key)" class="photo">
                                <div class="d-flex align-center justify-center photo-img" style="height: 160px;">
                                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                </div>
                              </div>
                              <div v-else><span>Nenhuma foto foi encontrada</span></div>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                      <div v-else><span>Tipo de campo desconhecido</span></div>
                    </v-tab-item>
                  </v-tabs-items>                
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn class="action-btn d-flex justify-center" height="36" width="10" color="primary" tile outlined
              @click="controller.closeFormDynamic(); controller.formDynamic = false;">
              <v-icon center>mdi-close</v-icon>
            </v-btn>
            <v-btn
              v-if="controller.fields && controller.fields.length && controller.tabs === (controller.fields.length - 1) && !controller.form?.approvedDate &&hadPermission(22,8) && !controller.form?.submittedDate"
              class="action-btn d-flex justify-center" height="36" width="160" color="primary" tile
              @click="controller.submitReport()"
            >
              <v-icon left>mdi-send</v-icon>
              Enviar relatório
            </v-btn>
            <v-btn v-else-if="controller.isReportComplete() && controller.form?.submittedDate" disabled
              class="action-btn d-flex justify-center" height="36" width="10" color="primary" tile
              >
              <v-icon center>mdi-clock-outline</v-icon>
            </v-btn>
            <v-btn
              v-if="controller.fields && controller.fields.length && controller.tabs === (controller.fields.length - 1) && controller.form?.submittedDate && !controller.form?.approvedDate && hadPermission(0,0)"
              class="action-btn d-flex justify-center" height="36" width="10" color="success" tile
              @click="controller.approveReport(controller.form)"
            >
              <v-icon center>mdi-check-circle</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import debounce from 'lodash/debounce'

import { visitServiceOrderController } from "@/di/di";

export default {
  name: "visit-service-order-page",
  data: (context) => ({
    controller: visitServiceOrderController(context),
  }),
  mounted() {
    this.updateVh()
    window.addEventListener('resize', this.updateVh)
  },
  watch: {
    "controller.formDynamic": {
      handler(val) {
        if (val === false) {
          this.controller.clearAllCameras();
        }
      },
      immediate: false
    },
    "controller.options"() {
      this.controller.watchOptions();
    },
    "controller.search"() {
      this.controller.watchSearch();
    },
    "controller.clientOptions"() {
      this.controller.watchClientOptions();
    },
    "controller.searchClient": debounce(function () {
      this.controller.watchClientSearch();
    }, 500),
    "controller.vehicleOptions"() {
      this.controller.watchVehicleOptions();
    },
    "controller.searchVehicle": debounce(function () {
      this.controller.watchVehicleSearch();
    }, 500),
    "controller.technicianOptions"() {
      this.controller.watchTechnicianOptions();
    },
    "controller.searchTechnician": debounce(function () {
      this.controller.watchTechnicianSearch();
    }, 500),
    "controller.taskTypeOptions"() {
      this.controller.watchTaskTypeOptions();
    },
    "controller.searchTaskType": debounce(function () {
      this.controller.watchTaskTypeSearch();
    }, 500),
    "controller.statusOptions"() {
      this.controller.watchStatusOptions();
    },
    "controller.searchStatus": debounce(function () {
      this.controller.watchStatusSearch();
    }, 500),
  },
  beforeDestroy() {
    try { window.removeEventListener('resize', this.updateVh) } catch (_) {}
    this.controller.clearAllCameras();
  },
  methods: {
    updateVh() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }
};
</script>

<style scoped lang="scss">
.astra-table {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

.toolbar-table {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}

::v-deep .v-data-table.v-data-table--fixed-header thead th {
  background-color: var(--v-secondary-base) !important;
}

.action-btn {
  text-transform: none;
  border-radius: 10px !important;
}

.search-tf {
  border-radius: 10px !important;
}

.table-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
}

.crud-card {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

::v-deep .v-dialog {
  border-radius: 20px !important;
}

label {
  order: -1;
}

.v-input:focus-within+label {
  color: var(--v-primary-base) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

.action {
  display: flex;
}

.take-photo {
  width: 300;
  height: 400;
  position: relative;
  display: inline-block;
}

.take-photo-sm {
  position: relative;
  display: inline-block;
}

.photo {
  width: 306px;
  justify-items: center;
  justify-self: center;
  align-items: center;
}

.photo-img {
  border-radius: 12px;
  overflow: hidden;
}

.photo-desktop {
  width: 500px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep tbody {
  tr:hover {
    background-color: var(--v-tertiary-base) !important;
  }
}

::v-deep .v-slide-group__content {
  white-space: normal !important;
  text-align: start !important;
}

.dialogBreakSm .v-dialog > * {
    width: auto;
}

.row-sm .row {
  display: block !important;
}

.report-dialog .v-card {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
.report-dialog .v-card__title,
.report-dialog .v-card__actions {
  flex-shrink: 0;
}
.report-dialog .v-card__text {
  overflow-y: auto;
}
.report-dialog {
  overflow: hidden !important;
}
</style>
